import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { mutate } from 'swr';
import { useGetCartData } from '../../../datafetchers/CartWidget';
import { addToCartHandler, getCartButton } from '../../../Utils/productAction';
import { navigateToCartPage } from '../../../Utils/redirections';
import { clickInstrumentationAddToCart } from '../../../Utils/StoreHomePageUtils';
import { AddToCartButtonFilled } from '../../StoreCategoryPage/SubCategoryProducts/styled';
import { CssLoader } from './styled';
import CardContext from '../ProductCard/ProductCardContext';

function AddToCartButton() {
  const contextData = useContext(CardContext);
  const { setChangeCartCount, cardData, productData, sectionId, sectionName } =
    contextData;
  const productId = productData?._id || productData?.id;
  const { data } = useGetCartData();
  const [showGoToCart, setShowGoToCart] = useState(false);
  const [loaderState, setLoaderState] = useState('');
  const router = useRouter();
  useEffect(() => {
    if (getCartButton(parseInt(productId)) === 2) {
      setShowGoToCart(true);
    } else {
      setShowGoToCart(false);
      setLoaderState('');
    }
  }, [router.query]);

  const clickedAddToCart = async () => {
    if (data) {
      await mutate('/api/getNewCartAmountOfUserWeb', null, false);
    }
    setLoaderState('loading');
    clickInstrumentationAddToCart(
      'clicked_add_to_cart',
      cardData,
      productData,
      sectionName,
      sectionId,
    );
    const addedToCart = await addToCartHandler(productId);
    setLoaderState('loaded');
    if (addedToCart) {
      setTimeout(() => {
        setShowGoToCart(true);
        setChangeCartCount(true);
      }, 800);
    }
    // }
  };
  const goToCartClickHandler = () => {
    clickInstrumentationAddToCart(
      'clicked_go_to_cart',
      cardData,
      productData,
      sectionName,
      sectionId,
    );
    //redirectToMyloUrl("/cart");
    navigateToCartPage();
  };

  return (
    <>
      {showGoToCart ? (
        <AddToCartButtonFilled
          onClick={goToCartClickHandler}
          className="add_btn_filled"
          verm
        >
          GO TO CART
        </AddToCartButtonFilled>
      ) : (
        <AddToCartButtonFilled
          onClick={clickedAddToCart}
          className="add_btn_filled"
        >
          {loaderState === 'loading' || loaderState === 'loaded' ? (
            <CssLoader
              aplusplus
              className={loaderState === 'loaded' ? 'load-complete' : ''}
            >
              <div
                className="checkmark draw"
                style={loaderState === 'loaded' ? { display: 'block' } : {}}
              ></div>
            </CssLoader>
          ) : (
            'ADD TO CART'
          )}
        </AddToCartButtonFilled>
      )}
    </>
  );
}

export default AddToCartButton;
